var _path, _path2, _circle, _path3, _circle2, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHorizontalDots(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 21,
    viewBox: "0 0 68 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.88773 15.5141C3.15406 12.7805 3.15406 8.3483 5.88773 5.61463C8.6214 2.88096 13.0536 2.88096 15.7872 5.61463C18.5209 8.3483 18.5209 12.7805 15.7872 15.5141C13.0536 18.2478 8.6214 18.2478 5.88773 15.5141Z",
    fill: "#02FFFF",
    stroke: "#02FFFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 11.179C19.8407 13.3781 18.9203 15.5324 17.2389 17.2139C13.524 20.9287 7.50101 20.9287 3.78615 17.2139C0.0712832 13.499 0.0712844 7.476 3.78615 3.76114C5.46759 2.07969 7.6219 1.15931 9.82102 1",
    stroke: "#02FFFF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 34.5,
    cy: 10.5,
    r: 7,
    transform: "rotate(-90 34.5 10.5)",
    fill: "#02FFFF",
    stroke: "#02FFFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3118 17C25.8714 15.304 25 13.0928 25 10.6744C25 5.33139 29.2533 1 34.5 1C39.7467 1 44 5.33138 44 10.6744C44 13.0928 43.1286 15.304 41.6882 17",
    stroke: "#02FFFF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 56.5,
    cy: 10.5,
    r: 7,
    stroke: "#02FFFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9658 3.31183C51.7679 1.87137 54.1172 1 56.6868 1C62.3637 1 66.9658 5.25329 66.9658 10.5C66.9658 15.7467 62.3637 20 56.6868 20C54.1172 20 51.7679 19.1286 49.9658 17.6882",
    stroke: "#02FFFF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHorizontalDots);
export default __webpack_public_path__ + "static/media/horizontal_dots.a9f6a081ff49f8a356de73c86cc31243.svg";
export { ForwardRef as ReactComponent };